import template from './sub-menu.html';

const subMenuDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	scope: {
		list: '=',
	},
	template,
	// /**
	//  * @param {any} scope
	//  * @param {any} element
	//  * @param {any} attributes
	//  * @param {import('./menu.controller').default} menuCtrl
	//  */
	// link(scope, element, attributes, menuCtrl) {
	// },
});

export default subMenuDirective;
